export const SAFEBUY_API_PATHS = {
  ORDERS_LIST: "/api/v1/orders/list",
  ORDER_DETAIL: "/api/v1/orders",
  MERCHANTS_LIST: "/api/v1/merchant-catalogue/merchants",
  MERCHANT_PROFILE: "/api/v1/merchant-catalogue/merchant",
  FAQ_COMMON: "/api/v1/faq/common",
  PAYOUT: "/api/v1/payout",
};

export const SAFEBUY_INTERNAL_API_PATHS = {
  ORDERS_LIST: "/api/safebuy-users/orders/list/",
  ORDER_DETAIL: "/api/safebuy-users/orders/",
  MERCHANTS_LIST: "/api/safebuy-users/merchants/list/",
  MERCHANT_PROFILE: "/api/safebuy-users/merchants/profile/",
  FAQ_COMMON: "/api/safebuy-users/faqs/",
  PAYOUT: "/api/safebuy-users/payout/",
};
